import { inject } from '@angular/core';
import { isDutch } from './is-dutch';

export function getDoodLogoUrl(): string {
  if (inject(isDutch)) {
    return '/assets/images/miam-company/logo-miam-company-bleu.png';
  }
  return '/assets/images/dood-logo/logo-dood-dark.png';
}

export function getDoodLogoWhiteUrl(): string {
  if (inject(isDutch)) {
    return '/assets/images/miam-company/logo-miam-company-white.png';
  }
  return '/assets/images/dood-logo/logo-dood-white.svg';
}
